import React, { useContext, useEffect, useState } from "react";
import { ECLLoader, ECLThemeImage } from "../../../";
import useSelectorId from "../../../../utilities/hooks/useSelectorId";
import { ToastContext } from "../../../../utilities/contexts";
import "./ECLMeasure.css";
import { translate } from "../../../../utilities/Translate";

//ECLMeasure
//DATA:
//    -value: takes a numeric value to be displayed.
//Draw Data:
//    -label: provides a label for the measure.
export default function ECLMeasure(props) {
   const measureId = useSelectorId();
   const [value, setValue] = useState(null);
   const [drawData, setDrawData] = useState(null);
   const [loading, setLoading] = useState(true);
   const [error, setError] = useState(null);
   const addToast = useContext(ToastContext);

   useEffect(() => {
      props
         .loader()
         .then((res) => {
            if (res.drawData?.content?.measureDisplayPrecision) {
               setValue(
                  typeof res.value == "number"
                     ? res.value.toFixed(
                          res.drawData.content.measureDisplayPrecision,
                       )
                     : res.value,
               );
            } else {
               setValue(res.value);
            }
            setDrawData(res.drawData);
            setLoading(false);
         })
         .catch((error) => {
            //Error handling here
            console.error(error);
            setError("Visualization request failed");
            addToast("Visualization request failed", "error");
         });
   }, [props.loader]);

   if (loading || error) {
      return <ECLLoader message={error} />;
   }
   let labelStyle = {
      color: "inherit",
   };

   let image;
   if (drawData?.content) {
      const { content } = drawData;
      // Configures Text Color Value
      if (content?.measureUseTextColor) {
         if (value > content.measureThreshholdValue) {
            labelStyle.color = content.measureHigherColorHex;
         }
         if (value < content.measureThreshholdValue) {
            labelStyle.color = content.measureLowerColorHex;
         }
      }
      // Configures Arrow Image
      if (content?.measureShowArrow) {
         if (value > content.measureThreshholdValue) {
            image = (
               <ECLThemeImage
                  id={"arrow-up"}
                  alt={translate("Arrow Up")}
                  fontAwesome={"arrow-up"}
                  colorOverride={content.measureHigherColorHex}
               />
            );
         }
         if (value < content.measureThreshholdValue) {
            image = (
               <ECLThemeImage
                  id={"arrow-down"}
                  alt={translate("Arrow Down")}
                  fontAwesome={"arrow-down"}
                  colorOverride={content.measureLowerColorHex}
               />
            );
         }
         // Diplay no arrow if value is equal to threshold
         if (value === content.measureThreshholdValue) {
            image = "";
         }
      }
   }

   return (
      <>
         {drawData?.content ? (
            //  Display ECLMeasure with Image and Text Colors
            <div className="ecl-measure-content-div">
               <label
                  htmlFor={"measure-" + measureId}
                  className="measure-label"
                  title={drawData.label}
               >
                  {drawData.label}
               </label>
               <div className="ecl-measure-text-div">
                  <p
                     style={labelStyle}
                     id={"measure-" + measureId}
                     className="measure-value"
                     title={value}
                  >
                     {value}
                  </p>
                  {drawData?.content?.measureShowArrow && image}
               </div>
            </div>
         ) : (
            // Display Normal ECLMeasure
            <div className="ecl-measure-content-div">
               <label
                  htmlFor={"measure-" + measureId}
                  className="measure-label"
                  title={drawData.label}
               >
                  {drawData.label}
               </label>
               <p
                  style={labelStyle}
                  id={"measure-" + measureId}
                  className="measure-value"
                  title={value}
               >
                  {value}
               </p>
            </div>
         )}
      </>
   );
}
